import React, { useContext, useEffect, useState } from 'react';
import JString from "@easytech-international-sdn-bhd/jstring";
import API_Service, { axiosDefaultConfig, axiosURIencode } from "../../Services/API_Service";
import AppContext from "../../Services/AppContext";
import {
    defDateFormat,
    empty,
    req_cust,
    req_delete_file,
    req_cust_area,
    req_gallery_v2,
    req_gallery_v2_report,
    req_gallery_checkedPhotos,
    req_gallery_download_single,
    req_gallery_type2,
    req_module_setting,
    req_salesman,
    req_settings_branches,
    req_gallery_rotateimage
} from "../../Helper/Constants";
import { de, getSetting } from "../../Helper/Helper";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from "@material-ui/core/styles";
import GridList from "react-gridlist";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import KeyboardArrowDownRoundedIcon from "@material-ui/icons/KeyboardArrowDownRounded";
import _ from "lodash";
import { useCommonStyles } from "../../Styles";
import moment from "moment/moment";
import DateRangePickerModal from "../../Components/DateRangePickerModal";
import PersistantData from "../../Services/PersistantData";
import format from "date-fns/format";
import VirtualListCB from "../../Components/VirtualListCB";
import VirtualListHierarchical from "../../Components/VirtualListHierarchical";
import { useSnackbar } from "notistack";
import IconButton from '@material-ui/core/IconButton';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Box from '@material-ui/core/Box';
import HistoryIcon from '@material-ui/icons/History';
import DescriptionIcon from '@material-ui/icons/Description';
import CircularProgress from '@material-ui/core/CircularProgress';
import Backdrop from '@material-ui/core/Backdrop';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import GetAppIcon from '@material-ui/icons/GetApp';
import { saveAs } from 'file-saver';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
        backdropFilter: 'blur(10px)',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
    },
    loadingContainer: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    loadingIconWrapper: {
        position: 'relative',
        width: 80,
        height: 80,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 24,
    },
    loadingRing: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        border: '3px solid transparent',
        borderTopColor: '#FEF200',
        animation: '$spin 1.5s linear infinite',
        '&:before': {
            content: '""',
            position: 'absolute',
            top: 5,
            left: 5,
            right: 5,
            bottom: 5,
            borderRadius: '50%',
            border: '3px solid transparent',
            borderTopColor: '#FFFFFF',
            animation: '$spin 3s linear infinite',
        }
    },
    loadingPulse: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 100,
        height: 100,
        borderRadius: '50%',
        backgroundColor: 'rgba(254, 242, 0, 0.15)',
        animation: '$pulse 2s ease-out infinite',
        zIndex: -1,
    },
    loadingIcon: {
        fontSize: 32,
        color: '#fff',
        animation: '$bounce 2s ease-in-out infinite',
    },
    '@keyframes spin': {
        '0%': { transform: 'rotate(0deg)' },
        '100%': { transform: 'rotate(360deg)' },
    },
    '@keyframes pulse': {
        '0%': { transform: 'translate(-50%, -50%) scale(0.8)', opacity: 0.8 },
        '100%': { transform: 'translate(-50%, -50%) scale(1.5)', opacity: 0 },
    },
    '@keyframes bounce': {
        '0%, 100%': { transform: 'translateY(0)' },
        '50%': { transform: 'translateY(-5px)' },
    },
    viewInRow: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'left',
        marginTop: theme.spacing(1),
        rowGap: 10
    },
    grid: {
        padding: theme.spacing(1),
        height: '100%'
    },
    paper: {
        width: 270,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        zIndex: theme.zIndex + 1,
    },
    maxImage: {
        width: 250,
        height: 300
    },
    largeImage: {
        maxWidth: '100%',
        maxHeight: '100%'
    },
    font: {
        textAlign: 'initial',
    },
    fontGrey: {
        color: 'grey'
    },
    // Report Version Dialog Styles
    dialogPaper: {
        borderRadius: 16,
        overflow: 'hidden',
    },
    dialogHeader: {
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        padding: '24px 28px',
        '& .MuiTypography-root': {
            fontWeight: 600,
            fontSize: '1.25rem',
            letterSpacing: '0.3px',
        },
    },
    dialogContent: {
        padding: '28px',
        backgroundColor: theme.palette.background.default,
    },
    versionCard: {
        display: 'flex',
        alignItems: 'center',
        padding: '18px 20px',
        borderRadius: 12,
        border: `2px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        marginBottom: 12,
        '&:last-child': {
            marginBottom: 0,
        },
        '&:hover': {
            borderColor: theme.palette.primary.main,
            backgroundColor: theme.palette.action.hover,
            transform: 'translateY(-2px)',
            boxShadow: `0 4px 12px ${theme.palette.primary.light}40`,
        },
    },
    versionCardSelected: {
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.light + '20',
        boxShadow: `0 4px 16px ${theme.palette.primary.light}40`,
        '&:hover': {
            backgroundColor: theme.palette.primary.light + '20',
        },
    },
    versionIcon: {
        width: 48,
        height: 48,
        borderRadius: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 16,
        flexShrink: 0,
    },
    versionIconLastVisit: {
        backgroundColor: theme.palette.info?.main || '#2196f3',
        color: '#fff',
    },
    versionIconDetailed: {
        backgroundColor: theme.palette.success?.main || '#4caf50',
        color: '#fff',
    },
    versionInfo: {
        flex: 1,
    },
    versionTitle: {
        fontWeight: 600,
        fontSize: '1rem',
        color: theme.palette.text.primary,
        marginBottom: 4,
    },
    versionDesc: {
        fontSize: '0.85rem',
        color: theme.palette.text.secondary,
        lineHeight: 1.4,
    },
    dialogActions: {
        padding: '16px 28px 24px',
        backgroundColor: theme.palette.background.default,
        gap: 12,
    },
    cancelBtn: {
        borderRadius: 8,
        padding: '10px 24px',
        textTransform: 'none',
        fontWeight: 500,
        color: theme.palette.text.secondary,
        border: `1px solid ${theme.palette.divider}`,
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
            borderColor: theme.palette.text.disabled,
        },
    },
    confirmBtn: {
        borderRadius: 8,
        padding: '10px 28px',
        textTransform: 'none',
        fontWeight: 600,
        backgroundColor: theme.palette.primary.main,
        boxShadow: `0 4px 12px ${theme.palette.primary.light}50`,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
            boxShadow: `0 6px 16px ${theme.palette.primary.light}70`,
        },
    },
}));

function getGridGap(elementWidth, windowHeight) {
    if (elementWidth > 720 && windowHeight > 480) {
        return 10
    } else {
        return 5
    }
}

function getColumnCount(elementWidth, gridGap) {
    return Math.floor((elementWidth + gridGap) / (300 + gridGap))
}

function getWindowMargin(windowHeight) {
    return Math.round(windowHeight * 1.5)
}

export default function Gallery2() {
    const [gState] = useContext(AppContext);
    const classes = useStyles();
    const commonStyle = useCommonStyles();
    const singleton = PersistantData.getInstance();
    var { translation: language, client } = gState;
    if (typeof (language) === 'undefined') {
        language = singleton.getlang()
    }
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [splist, setSPlist] = useState([]);
    const [outletList, setOutletList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [imgList, setImgList] = useState([]);
    const [datePickerModal, setDatePickerModal] = useState(false);
    const [galleryDateRange, setGalleryDateRange] = useState({});

    const [agentAttendSpView, setAgentAttendSpView] = useState(false);
    const [agentAttendOutletView, setAgentAttendOutletView] = useState(false);
    const [categoryView, setCategoryView] = useState(false);
    const [selectedCategoryName, setSelectedCategoryName] = useState(empty);
    const [selectedCategoryValue, setSelectedCategoryValue] = useState([]);
    const [agentAttendOutlet, setAgentAttendOutlet] = useState(empty);
    const [agentAttendOutletSelect, setAgentAttendOutletSelected] = useState(empty);
    const [agentAttendSpSelect, setAgentAttendSpSelected] = useState(empty);
    const [agentAttendSalesperson, setAgentAttendSalesperson] = useState(empty);

    const [selectedImage, setSelectedImage] = useState(null);
    const [imageZoom, setImageZoom] = useState(1);
    const [imagePosition, setImagePosition] = useState({ x: 0, y: 0 });
    const [imageRotation, setImageRotation] = useState(0);
    const [imageIndex, setImageIndex] = useState(0);
    const [isSavingRotation, setIsSavingRotation] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
    const [dragStartPosition, setDragStartPosition] = useState({ x: 0, y: 0 });
    const [checkedState, setCheckedState] = useState([]);
    const [isDownloading, setIsDownloading] = useState(false);

    const [areaList, setAreaList] = useState([]);
    const [areaView, setAreaView] = useState(false);
    const [selectedArea, setSelectedArea] = useState(empty);

    const [branchesList, setBranchesList] = useState([]);
    const [branchesView, setBranchesView] = useState(false);
    const [branchSelectedValue, setBranchSelectedValue] = useState(empty);
    const [branchSelectedName, setBranchSelectedName] = useState(empty);
    const [reportVersionDialog, setReportVersionDialog] = useState(false);
    const [selectedReportVersion, setSelectedReportVersion] = useState('last_visit');

    useEffect(() => {
        if (JString(gState.client).isValid()) {
            var axiosGetConfig = axiosDefaultConfig(gState.client);
            // loadGallery(axiosGetConfig);
            getSalesmanList(gState.client);
            getOutletList(gState.client);
            loadGalleryType(axiosGetConfig);
            loadConfig(gState.client);
            getAreaList(gState.client);
            getBranches(gState.client);
        }
    }, [gState.client]);

    const getGalleryDate = () => {
        return !_.isEmpty(galleryDateRange) ? moment(galleryDateRange.startDate).format('DD MMMM YYYY') + " / " + moment(galleryDateRange.endDate).format('DD MMMM YYYY') : moment(new Date()).format('DD MMMM YYYY') + " / " + moment(new Date()).format('DD MMMM YYYY');
    }

    const snack = (msg, type = 'success') => {
        enqueueSnackbar(msg, {
            variant: type,
            preventDuplicate: true,
            autoHideDuration: type === 'success' ? 2000 : 3000
        });
    }

    // Image Viewer Handlers
    const handleMouseDown = (e) => {
        if (imageZoom > 1) {
            setIsDragging(true);
            setDragStart({ x: e.clientX, y: e.clientY });
            setDragStartPosition({ x: imagePosition.x, y: imagePosition.y });
            e.preventDefault();
        }
    };

    const handleMouseMove = (e) => {
        if (isDragging && imageZoom > 1) {
            const deltaX = e.clientX - dragStart.x;
            const deltaY = e.clientY - dragStart.y;
            setImagePosition({
                x: dragStartPosition.x + deltaX,
                y: dragStartPosition.y + deltaY
            });
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    useEffect(() => {
        if (isDragging) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            return () => {
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
            };
        }
    }, [isDragging, dragStart, dragStartPosition]);

    const handleSaveRotation = () => {
        if (!selectedImage || imageRotation === 0 || isSavingRotation) return;
        setIsSavingRotation(true);

        const normalizedRotation = ((imageRotation % 360) + 360) % 360;
        const formData = new FormData();
        formData.append('upload_id', selectedImage.upload_id);
        formData.append('angle', normalizedRotation);

        API_Service.post(req_gallery_rotateimage, formData, axiosDefaultConfig(gState.client)).then(({ data }) => {
            const { result, extraData } = data;
            if (parseInt(result) === 1) {
                const baseUrl = extraData.upload_image;
                const newUrl = `${baseUrl}?t=${Date.now()}`;
                setSelectedImage(prev => ({ ...prev, upload_image: newUrl }));
                setImgList(prev => prev.map(item =>
                    item.upload_id === selectedImage.upload_id
                        ? { ...item, upload_image: newUrl }
                        : item
                ));
                setImageRotation(0);
                snack('Image saved successfully', 'success');
            } else {
                snack('Failed to save image', 'error');
            }
            setIsSavingRotation(false);
        }).catch((e) => {
            console.error(e);
            snack('Failed to save image', 'error');
            setIsSavingRotation(false);
        });
    };

    const handleDownloadCurrentImage = () => {
        if (!selectedImage || isDownloading) return;
        setIsDownloading(true);
        const param = axiosURIencode({
            client: client,
            upload_id: selectedImage.upload_id
        });
        API_Service.get(`${req_gallery_download_single}?${param}`, axiosDefaultConfig(client)).then(({ data }) => {
            const { result, message, extraData } = data;
            if (parseInt(result) === 1 && extraData && extraData.data) {
                try {
                    const byteChars = atob(extraData.data);
                    const byteArr = new Uint8Array(byteChars.length);
                    for (let i = 0; i < byteChars.length; i++) byteArr[i] = byteChars.charCodeAt(i);
                    const blob = new Blob([byteArr], { type: extraData.mime || 'image/jpeg' });
                    const safe = (v) => String(v == null ? '' : v).replace(/[^a-zA-Z0-9_-]/g, '_');
                    const filename = `${safe(selectedImage.cust_code)}_${safe(selectedImage.taken_date)}_${safe(selectedImage.upload_id)}.jpg`;
                    saveAs(blob, filename);
                    snack(language.download_success, 'success');
                } catch (e) {
                    snack(language.download_failed, 'error');
                }
            } else {
                snack(message || language.download_failed, 'error');
            }
            setIsDownloading(false);
        }).catch(() => {
            snack(language.download_failed, 'error');
            setIsDownloading(false);
        });
    };

    const handleSelectImage = (image) => {
        const idx = imgList.findIndex(item => item.upload_id === image.upload_id);
        setSelectedImage(image);
        setImageIndex(idx >= 0 ? idx : 0);
        setImageZoom(1);
        setImagePosition({ x: 0, y: 0 });
        setImageRotation(0);
    };

    const handleCloseImageViewer = () => {
        setSelectedImage(null);
        setImageZoom(1);
        setImagePosition({ x: 0, y: 0 });
        setImageRotation(0);
        setImageIndex(0);
    };

    const handlePrevImage = () => {
        if (imageIndex > 0) {
            const newIndex = imageIndex - 1;
            setSelectedImage(imgList[newIndex]);
            setImageIndex(newIndex);
            setImageZoom(1);
            setImagePosition({ x: 0, y: 0 });
            setImageRotation(0);
        }
    };

    const handleNextImage = () => {
        if (imageIndex < imgList.length - 1) {
            const newIndex = imageIndex + 1;
            setSelectedImage(imgList[newIndex]);
            setImageIndex(newIndex);
            setImageZoom(1);
            setImagePosition({ x: 0, y: 0 });
            setImageRotation(0);
        }
    };

    const canNavigate = imgList.length > 1;
    const canGoPrev = imageIndex > 0;
    const canGoNext = imageIndex < imgList.length - 1;

    const loadConfig = (_client = client) => {
        API_Service.get(req_module_setting, axiosDefaultConfig(_client)).then(({ data }) => {
            const { result, extraData } = data;
            if (result == 1) {
                const _config = getSetting(extraData, 'customization', {});
            }
        });
    }

    const getAreaList = (_client = client) => {
        API_Service.get(req_cust_area, axiosDefaultConfig(_client)).then(({ data }) => {
            const { result, extraData } = data;
            if (parseInt(result) === 1) {
                var _data = [];
                for (let idx = 0; idx < extraData.length; idx++) {
                    const { area_name, area_code, area_status } = extraData[idx];
                    _data.push({ name: area_name, secondary: area_code, value: area_code, status: parseInt(area_status) });
                }
                setAreaList(_data);
            }
        });
    }

    const AreaViewClick = () => {
        setAreaView(true);
    }

    const AreaViewClose = (newValue) => {
        setAreaView(false);
        if (newValue) {
            var value = '';
            for (let i = 0; i < newValue.length; i++) {
                if (i == newValue.length - 1) {
                    value += newValue[i].value;
                } else {
                    value += newValue[i].value + ",";
                }
            }
            setSelectedArea(value);
        }
    }

    const getBranches = (_client = client) => {
        API_Service.get(req_settings_branches, axiosDefaultConfig(_client)).then(({ data }) => {
            const { result, extraData } = data;
            if (result) {
                setBranchesList(branchesList => (extraData));
            }
        }).catch(de);
    }

    const BranchesViewClose = (newValue) => {
        setBranchesView(false);
        if (newValue) {
            var value = '';
            for (let i = 0; i < newValue.length; i++) {
                if (i == newValue.length - 1) {
                    value += newValue[i].value;
                } else {
                    value += newValue[i].value + ",";
                }
            }
            setBranchSelectedValue(value);

            var name = '';
            for (let i = 0; i < newValue.length; i++) {
                if (i == newValue.length - 1) {
                    name += newValue[i].name;
                } else {
                    name += newValue[i].name + ",";
                }
            }
            setBranchSelectedName(name);
        }
    }

    const loadGallery = (_client = client) => {
        var st_date = '';
        var st_date_to = '';
        if (!_.isEmpty(galleryDateRange)) {
            st_date = format(galleryDateRange.startDate, defDateFormat);
            st_date_to = format(galleryDateRange.endDate, defDateFormat);
        }

        var parameters = {
            salesperson_id: agentAttendSpSelect,
            cust_code: agentAttendOutletSelect,
            type: selectedCategoryName,
            category_list: JSON.stringify(selectedCategoryValue),
            start_date: st_date,
            end_date: st_date_to,
            area: selectedArea
        };
        if (gState.company) {
            parameters.company = gState.company;
        }
        if (branchSelectedValue !== empty) {
            parameters.company = JSON.stringify(branchSelectedValue.split(","));
        }

        const params = axiosURIencode(parameters);

        API_Service.get(`${req_gallery_v2}?${params}`, axiosDefaultConfig(_client)).then(({ data }) => {
            const { result, extraData } = data;
            if (result == 1) {
                setImgList(imgList => (extraData));
            } else {
                setImgList(imgList => ([]));
                snack(language.no_data, 'warning');
            }
            setCheckedState(new Array(extraData.length).fill(false))
        });
    }

    const getSalesmanList = (_client = client) => {
        var parameters = '';
        if (gState.company) {
            const param = axiosURIencode({
                company: gState.company,
            });
            parameters = `?${param}`;
        }
        API_Service.get(`${req_salesman}${parameters}`, axiosDefaultConfig(_client)).then(({ data }) => {
            const { result, extraData } = data;
            if (result) {
                var _data = [];
                for (let idx = 0; idx < extraData.length; idx++) {
                    const { name, login_id, login, login_status } = extraData[idx];
                    _data.push({ name: name, secondary: login, value: login_id, status: parseInt(login_status) });
                }
                setSPlist(splist => (_data));
            }
        });
    }

    const getOutletList = (_client = client) => {
        var parameters = '';
        if (gState.company) {
            const param = axiosURIencode({
                company: gState.company,
            });
            parameters = `?${param}`;
        }
        API_Service.get(`${req_cust}${parameters}`, axiosDefaultConfig(_client)).then(({ data }) => {
            const { result, extraData } = data;
            var { customer, inactive_customer } = extraData;
            if (parseInt(result) === 1) {
                var arr = [];
                for (let i = 0; i < customer.length; i++) {
                    const { cust_code, cust_company_name } = customer[i];
                    arr.push({
                        name: cust_company_name,
                        secondary: cust_code,
                        value: cust_code,
                        status: 1
                    });
                }
                for (let i = 0; i < inactive_customer.length; i++) {
                    const { cust_code, cust_company_name } = inactive_customer[i];
                    arr.push({
                        name: cust_company_name,
                        secondary: cust_code,
                        value: cust_code,
                        status: 0
                    });
                }
                setOutletList(arr);
            }
        });
    }

    const loadGalleryType = (axiosGetConfig) => {
        API_Service.get(req_gallery_type2, axiosGetConfig).then(({ data }) => {
            console.log('data', data);

            const { result, extraData } = data;
            if (result == 1) {
                // 直接传递层次化数据给新组件
                setCategoryList(extraData);
            }
        });
    }

    const AgentAttendSPViewClose = (newValue) => {
        setAgentAttendSpView(false);
        if (newValue) {
            var spvalue = '';
            for (let i = 0; i < newValue.length; i++) {
                if (i == newValue.length - 1) {
                    spvalue += newValue[i].value;
                } else {
                    spvalue += newValue[i].value + ",";
                }
            }
            setAgentAttendSpSelected(spvalue);

            var spname = '';
            for (let i = 0; i < newValue.length; i++) {
                if (i == newValue.length - 1) {
                    spname += newValue[i].name;
                } else {
                    spname += newValue[i].name + ",";
                }
            }
            setAgentAttendSalesperson(spname);
        }
    }

    const AgentAttendOutletViewClose = (newValue) => {
        setAgentAttendOutletView(false);
        if (newValue) {
            var ovalue = '';
            for (let i = 0; i < newValue.length; i++) {
                if (i == newValue.length - 1) {
                    ovalue += newValue[i].value;
                } else {
                    ovalue += newValue[i].value + ",";
                }
            }
            setAgentAttendOutletSelected(ovalue);

            var oname = '';
            for (let i = 0; i < newValue.length; i++) {
                if (i == newValue.length - 1) {
                    oname += newValue[i].name;
                } else {
                    oname += newValue[i].name + ",";
                }
            }
            setAgentAttendOutlet(oname);
        }
    }

    const categoryOnClosed = (value) => {
        setCategoryView(false);

        // 处理重置情况
        if (value && (value.name === 'reset' || value === false)) {
            setSelectedCategoryName(empty);
            setSelectedCategoryValue([]);
            return;
        }

        if (value && Array.isArray(value) && value.length > 0) {
            var data = '';
            for (let i = 0; i < value.length; i++) {
                if (i == value.length - 1) {
                    data += value[i].name.toString();
                } else {
                    data += value[i].name.toString() + ",";
                }
            }
            setSelectedCategoryName(data);

            var data_list = [];
            for (let i = 0; i < value.length; i++) {
                data_list.push(value[i].value);
            }
            setSelectedCategoryValue(data_list);
        } else {
            // 如果没有选择项，清空选择
            setSelectedCategoryName(empty);
            setSelectedCategoryValue([]);
        }
    }

    const handleOnChange = (position) => {
        const updatedCheckedState = checkedState.map((item, index) =>
            index === position ? !item : item
        );
        setCheckedState(updatedCheckedState);
    };

    const downloadCheckedImages = (_client = client) => {
        let uploadArray = [];
        for (let i = 0; i < imgList.length; i++) {
            if (checkedState[i]) {
                const image = imgList[i];
                uploadArray.push(image.upload_id)
            }
        }

        if (uploadArray.length > 0) {
            setIsDownloading(true);
            const param = axiosURIencode({
                client: client,
                imageArray: uploadArray
            });

            API_Service.get(`${req_gallery_checkedPhotos}?${param}`, axiosDefaultConfig(_client)).then(({ data }) => {
                var { result, message, extraData } = data;
                if (result) {
                    window.open(extraData.url, '_blank');
                    const delay = setTimeout(() => {
                        API_Service.get(`${req_delete_file}?filename=${extraData.filename}`, axiosDefaultConfig(_client));
                        clearTimeout(delay);
                    }, 5000);
                }
                setIsDownloading(false);
            }).catch((e) => {
                setIsDownloading(false);
                console.error(e);
            });
        } else {
            snack("No image selected", 'warning');
        }

    };

    const generateReport = (version, _client = client) => {
        var st_date = '';
        var st_date_to = '';
        if (!_.isEmpty(galleryDateRange)) {
            st_date = format(galleryDateRange.startDate, defDateFormat);
            st_date_to = format(galleryDateRange.endDate, defDateFormat);
        }

        var parameters = {
            salesperson_id: agentAttendSpSelect,
            cust_code: agentAttendOutletSelect,
            type: selectedCategoryName,
            category_list: JSON.stringify(selectedCategoryValue),
            start_date: st_date,
            end_date: st_date_to,
            area: selectedArea,
            version: version
        };
        if (gState.company) {
            parameters.company = gState.company;
        }
        if (branchSelectedValue !== empty) {
            parameters.company = JSON.stringify(branchSelectedValue.split(","));
        }

        const params = axiosURIencode(parameters);

        API_Service.get(`${req_gallery_v2_report}?${params}`, axiosDefaultConfig(_client)).then(({ data }) => {
            const { result, extraData } = data;
            if (result == 1) {
                window.open(extraData.url, '_blank');
            } else {
                snack(language.no_data, 'warning');
            }
        });
    }

    const handleReportVersionConfirm = () => {
        setReportVersionDialog(false);
        generateReport(selectedReportVersion);
    }

    const handleReportVersionCancel = () => {
        setReportVersionDialog(false);
        setSelectedReportVersion('last_visit');
    }

    const resetChecked = () => {
        setCheckedState(new Array(imgList.length).fill(false))
    }

    return (
        <div>
            <div className={classes.viewInRow}>
                <Button
                    style={{ width: 300, marginRight: 10 }}
                    variant="outlined"
                    onClick={() => setAgentAttendSpView(true)}
                    endIcon={<KeyboardArrowDownRoundedIcon />}>
                    <Typography className={commonStyle.searchBtnFont}>
                        {agentAttendSalesperson ? _.truncate(agentAttendSalesperson, { length: 20 }) : language.salesperson}
                    </Typography>
                </Button>
                <Button
                    style={{ width: 300, marginRight: 10 }}
                    variant="outlined"
                    onClick={() => setAgentAttendOutletView(true)}
                    endIcon={<KeyboardArrowDownRoundedIcon />}>
                    <Typography className={commonStyle.searchBtnFont}>
                        {agentAttendOutlet ? _.truncate(agentAttendOutlet, { length: 20 }) : language.customer}
                    </Typography>
                </Button>
                <Button
                    style={{ width: 300, marginRight: 10 }}
                    variant="outlined"
                    onClick={() => AreaViewClick()}
                    endIcon={<KeyboardArrowDownRoundedIcon />}>
                    <Typography className={commonStyle.searchBtnFont}>
                        {selectedArea ? _.truncate(selectedArea, { length: 20 }) : "Area"}
                    </Typography>
                </Button>
                <Button
                    style={{ width: 300, marginRight: 10 }}
                    variant="outlined"
                    onClick={() => setCategoryView(true)}
                    endIcon={<KeyboardArrowDownRoundedIcon />}>
                    <Typography className={commonStyle.searchBtnFont}>
                        {selectedCategoryName ? _.truncate(selectedCategoryName, { length: 20 }) : language.photo_type}
                    </Typography>
                </Button>
                {
                    !gState.company && branchesList.length > 0 && (
                        <Button
                            style={{ width: 300, marginRight: 10 }}
                            variant="outlined"
                            onClick={() => setBranchesView(true)}
                            endIcon={<KeyboardArrowDownRoundedIcon />}>
                            <Typography className={commonStyle.searchBtnFont}>
                                {branchSelectedName ? _.truncate(branchSelectedName, { length: 20 }) : "Branch"}
                            </Typography>
                        </Button>
                    )
                }
                <Button
                    style={{ width: 300, marginRight: 10 }}
                    variant="outlined"
                    onClick={() => setDatePickerModal(true)}>
                    <Typography className={commonStyle.searchBtnFont}>
                        {getGalleryDate()}
                    </Typography>
                </Button>
                <Button
                    size="small"
                    color="primary"
                    variant={'contained'}
                    onClick={() => loadGallery()}>
                    <Typography className={commonStyle.searchBtnFont}>
                        {language.view}
                    </Typography>
                </Button>
                <div style={{ width: 10 }} />
                <Button
                    size="small"
                    color="primary"
                    variant={'contained'}
                    disabled={isDownloading}
                    onClick={() => downloadCheckedImages()}>
                    {isDownloading && <CircularProgress size={24} color="inherit" style={{position: 'absolute'}} />}
                    <Typography className={commonStyle.searchBtnFont}>
                        {isDownloading ? 'Downloading...' : 'Download'}
                    </Typography>
                </Button>
                <div style={{ width: 10 }} />
                <Button
                    size="small"
                    color="primary"
                    variant={'contained'}
                    onClick={() => setReportVersionDialog(true)}>
                    <Typography className={commonStyle.searchBtnFont}>
                        Generate Report
                    </Typography>
                </Button>
                <div style={{ width: 10 }} />
                <Button
                    size="small"
                    color="primary"
                    variant={'contained'}
                    onClick={() => resetChecked()}>
                    <Typography className={commonStyle.searchBtnFont}>
                        Reset
                    </Typography>
                </Button>
            </div>
            <div style={{ paddingTop: 40 }}>
                {
                    imgList.length > 0 && (
                        <GridList
                            items={imgList}
                            getGridGap={getGridGap}
                            getColumnCount={getColumnCount}
                            getWindowMargin={getWindowMargin}
                            getItemData={(item, cwidth) => {
                                let adjustedHeight = Math.round(cwidth * 1.12)
                                return {
                                    key: item.upload_image,
                                    height: 600,
                                }
                            }}
                            renderItem={(image) => {
                                return (
                                    <Grid container spacing={3} className={classes.grid}>
                                        <Paper className={classes.paper}>
                                            <img src={image.upload_image} onClick={() => handleSelectImage(image)} className={classes.maxImage} />
                                            <Typography variant="inherit" component="p" className={classes.fontGrey + ' ' + classes.font}>
                                                {image.cust_code}
                                            </Typography>
                                            <Typography variant="inherit" component="h4" className={classes.font}>
                                                {image.cust_company_name}
                                            </Typography>
                                            <Typography variant="inherit" component="p" className={classes.font} style={{ display: 'flex' }}>
                                                <span style={{ width: '80px' }}>Chain:</span><span style={{ width: '70%' }}>{image.cust_chain_name}</span>
                                            </Typography>
                                            <Typography variant="inherit" component="p" className={classes.font} style={{ display: 'flex' }}>
                                                <span style={{ width: '80px' }}>Area:</span><span style={{ width: '70%' }}>{image.cust_area}</span>
                                            </Typography>
                                            <Typography variant="inherit" component="p" className={classes.font} style={{ display: 'flex' }}>
                                                <span style={{ width: '80px' }}>Category:</span><span style={{ width: '70%' }}>{image.cust_category_name}</span>
                                            </Typography>
                                            <Typography variant="inherit" component="p" className={classes.font} style={{ display: 'flex' }}>
                                                <span style={{ width: '80px' }}>Agent:</span><span style={{ width: '70%' }}>{image.name}</span>
                                            </Typography>
                                            <Typography variant="inherit" component="p" className={classes.font} style={{ display: 'flex' }}>
                                                <span style={{ width: '80px' }}>Remark:</span><span style={{ width: '70%' }}>{image.upload_remark}</span>
                                            </Typography>
                                            <Typography variant="inherit" component="p" className={classes.font} style={{ display: 'flex' }}>
                                                <span style={{ width: '80px' }}>Type:</span><span style={{ width: '70%' }}>{image.upload_type_name}</span>
                                            </Typography>
                                            {
                                                image?.company && (
                                                    <Typography variant="inherit" component="p" className={classes.font} style={{ display: 'flex' }}>
                                                        <span style={{ width: '80px' }}>Branch:</span><span style={{ width: '70%' }}>{image.company.toUpperCase()}</span>
                                                    </Typography>
                                                )
                                            }
                                            <Typography variant="inherit" component="p" className={classes.font}>
                                                {moment(image.taken_date).format('DD/MM/YYYY HH:mmA')}
                                                <Checkbox
                                                    checked={checkedState[imgList.indexOf(image)]}
                                                    onChange={function () { handleOnChange(imgList.indexOf(image)) }}
                                                    color={'primary'}
                                                />
                                            </Typography>
                                        </Paper>
                                    </Grid>
                                )
                            }}
                        />
                    )
                }
            </div>

            <VirtualListCB
                open={agentAttendSpView}
                setClose={data => AgentAttendSPViewClose(data)}
                title={language.salesperson}
                data={splist}
                language={language}
                filteration={1}
            />

            <VirtualListCB
                open={agentAttendOutletView}
                setClose={data => AgentAttendOutletViewClose(data)}
                title={"Outlet"}
                data={outletList}
                language={language}
                filteration={1}
            />

            <VirtualListHierarchical
                open={categoryView}
                setClose={data => categoryOnClosed(data)}
                title={language.photo_type}
                data={categoryList}
                language={language}
                filteration={1}
            />

            <VirtualListCB
                open={areaView}
                setClose={data => AreaViewClose(data)}
                title={"Area"}
                data={areaList}
                language={language}
                filteration={1}
            />

            <VirtualListCB
                open={branchesView}
                setClose={data => BranchesViewClose(data)}
                title={"Branch"}
                data={branchesList}
                language={language}
                filteration={0}
            />

            <DateRangePickerModal
                setPositive={range => {
                    setGalleryDateRange(range);
                    setDatePickerModal(false)
                }}
                setNegative={() => {
                    setDatePickerModal(false)
                }}
                setClose={() => {
                    setDatePickerModal(false)
                }}
                open={datePickerModal}
                message={language.date_range}
                positive={language.ok}
            />

            <Dialog
                open={reportVersionDialog}
                onClose={handleReportVersionCancel}
                PaperProps={{ className: classes.dialogPaper }}
            >
                <DialogTitle className={classes.dialogHeader}>
                    Select Report Version
                </DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    {/* Last Visit Version Card */}
                    <Box
                        className={`${classes.versionCard} ${selectedReportVersion === 'last_visit' ? classes.versionCardSelected : ''}`}
                        onClick={() => setSelectedReportVersion('last_visit')}
                    >
                        <Box className={`${classes.versionIcon} ${classes.versionIconLastVisit}`}>
                            <HistoryIcon style={{ fontSize: 26 }} />
                        </Box>
                        <Box className={classes.versionInfo}>
                            <Typography className={classes.versionTitle}>
                                Last Visit Version
                            </Typography>
                            <Typography className={classes.versionDesc}>
                                Shows data from the most recent visit only
                            </Typography>
                        </Box>
                    </Box>

                    {/* Detailed Version Card */}
                    <Box
                        className={`${classes.versionCard} ${selectedReportVersion === 'detailed' ? classes.versionCardSelected : ''}`}
                        onClick={() => setSelectedReportVersion('detailed')}
                    >
                        <Box className={`${classes.versionIcon} ${classes.versionIconDetailed}`}>
                            <DescriptionIcon style={{ fontSize: 26 }} />
                        </Box>
                        <Box className={classes.versionInfo}>
                            <Typography className={classes.versionTitle}>
                                Detailed Version
                            </Typography>
                            <Typography className={classes.versionDesc}>
                                Comprehensive report with all visit details
                            </Typography>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    <Button
                        onClick={handleReportVersionCancel}
                        className={classes.cancelBtn}
                        variant="outlined"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleReportVersionConfirm}
                        className={classes.confirmBtn}
                        variant="contained"
                        color="primary"
                    >
                        Generate Report
                    </Button>
                </DialogActions>
            </Dialog>

            {selectedImage && (
                <Dialog
                    fullWidth={true}
                    maxWidth={'lg'}
                    open={selectedImage != null}
                    aria-labelledby="form-dialog-title"
                    onClose={handleCloseImageViewer}>
                    <DialogContent style={{
                        height: '85vh',
                        display: 'flex',
                        flexDirection: 'column',
                        padding: 0,
                        overflow: 'hidden',
                        position: 'relative'
                    }}>
                        {selectedImage && (
                            <>
                                {/* Image Container */}
                                <div style={{
                                    flex: 1,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    overflow: 'hidden',
                                    backgroundColor: '#000',
                                    position: 'relative'
                                }}>
                                    <img
                                        src={selectedImage.upload_image}
                                        alt="Gallery"
                                        onMouseDown={handleMouseDown}
                                        style={{
                                            maxWidth: '800px',
                                            maxHeight: '100%',
                                            width: 'auto',
                                            height: 'auto',
                                            objectFit: 'contain',
                                            transform: `translate(${imagePosition.x}px, ${imagePosition.y}px) rotate(${imageRotation}deg) scale(${imageZoom})`,
                                            transformOrigin: 'center center',
                                            transition: isDragging ? 'none' : 'transform 0.2s ease-out',
                                            userSelect: 'none',
                                            cursor: imageZoom > 1 ? (isDragging ? 'grabbing' : 'grab') : 'default'
                                        }}
                                    />

                                    {imageZoom > 1 && !isDragging && (
                                        <div style={{
                                            position: 'absolute',
                                            top: '20px',
                                            left: '20px',
                                            backgroundColor: 'rgba(0,0,0,0.7)',
                                            color: 'white',
                                            padding: '8px 12px',
                                            borderRadius: '6px',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            pointerEvents: 'none',
                                            opacity: 0.8,
                                            zIndex: 10
                                        }}>
                                            Drag to move or use direction controls
                                        </div>
                                    )}

                                    {/* Image Navigation Arrows */}
                                    {canNavigate && (
                                        <>
                                            <IconButton
                                                onClick={handlePrevImage}
                                                disabled={!canGoPrev}
                                                style={{
                                                    position: 'absolute',
                                                    left: 16,
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    backgroundColor: canGoPrev ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0.2)',
                                                    color: canGoPrev ? '#fff' : 'rgba(255,255,255,0.3)',
                                                    zIndex: 10,
                                                    width: 44,
                                                    height: 44,
                                                }}
                                            >
                                                <ArrowBackIcon />
                                            </IconButton>
                                            <IconButton
                                                onClick={handleNextImage}
                                                disabled={!canGoNext}
                                                style={{
                                                    position: 'absolute',
                                                    right: 16,
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    backgroundColor: canGoNext ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0.2)',
                                                    color: canGoNext ? '#fff' : 'rgba(255,255,255,0.3)',
                                                    zIndex: 10,
                                                    width: 44,
                                                    height: 44,
                                                }}
                                            >
                                                <ArrowForwardIcon />
                                            </IconButton>
                                            <div style={{
                                                position: 'absolute',
                                                top: 16,
                                                right: 16,
                                                backgroundColor: 'rgba(0,0,0,0.6)',
                                                color: '#fff',
                                                padding: '4px 12px',
                                                borderRadius: 20,
                                                fontSize: 13,
                                                fontWeight: 600,
                                                zIndex: 10,
                                                letterSpacing: '0.5px',
                                            }}>
                                                {imageIndex + 1} / {imgList.length}
                                            </div>
                                        </>
                                    )}
                                </div>

                                {/* Control Bar */}
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    padding: '14px 24px',
                                    backgroundColor: '#FEF200',
                                    borderTop: 'none',
                                    gap: '12px',
                                    boxShadow: '0 -4px 20px rgba(0,0,0,0.08)'
                                }}>
                                    {/* Zoom Controls Group */}
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        backgroundColor: 'rgba(255,255,255,0.95)',
                                        borderRadius: '12px',
                                        padding: '6px 8px',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                                        gap: '2px'
                                    }}>
                                        <IconButton
                                            onClick={() => {
                                                const newZoom = Math.max(1, imageZoom - 0.1);
                                                setImageZoom(newZoom);
                                                if (newZoom === 1) {
                                                    setImagePosition({ x: 0, y: 0 });
                                                }
                                            }}
                                            disabled={imageZoom <= 1}
                                            style={{
                                                backgroundColor: imageZoom > 1 ? '#f0f0f0' : 'transparent',
                                                width: '34px',
                                                height: '34px',
                                                borderRadius: '8px',
                                                transition: 'all 0.15s ease'
                                            }}
                                        >
                                            <Typography style={{
                                                fontSize: '18px',
                                                fontWeight: '600',
                                                color: imageZoom > 1 ? '#1a1a1a' : '#aaa',
                                                lineHeight: 1
                                            }}>
                                                -
                                            </Typography>
                                        </IconButton>

                                        <div style={{
                                            minWidth: '64px',
                                            padding: '4px 8px',
                                            textAlign: 'center'
                                        }}>
                                            <Typography
                                                style={{
                                                    fontWeight: '700',
                                                    color: '#1a1a1a',
                                                    fontSize: '13px',
                                                    letterSpacing: '-0.3px'
                                                }}
                                            >
                                                {Math.round(imageZoom * 100)}%
                                            </Typography>
                                        </div>

                                        <IconButton
                                            onClick={() => {
                                                setImageZoom(Math.min(5, imageZoom + 0.1));
                                            }}
                                            disabled={imageZoom >= 5}
                                            style={{
                                                backgroundColor: imageZoom < 5 ? '#f0f0f0' : 'transparent',
                                                width: '34px',
                                                height: '34px',
                                                borderRadius: '8px',
                                                transition: 'all 0.15s ease'
                                            }}
                                        >
                                            <Typography style={{
                                                fontSize: '18px',
                                                fontWeight: '600',
                                                color: imageZoom < 5 ? '#1a1a1a' : '#aaa',
                                                lineHeight: 1
                                            }}>
                                                +
                                            </Typography>
                                        </IconButton>
                                    </div>

                                    {/* Direction Controls Group */}
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        backgroundColor: 'rgba(255,255,255,0.95)',
                                        borderRadius: '12px',
                                        padding: '6px',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
                                    }}>
                                        <div style={{
                                            display: 'grid',
                                            gridTemplateColumns: 'repeat(3, 30px)',
                                            gap: '2px'
                                        }}>
                                            <div />
                                            <IconButton
                                                onClick={() => {
                                                    setImagePosition({
                                                        x: imagePosition.x,
                                                        y: imagePosition.y + 50
                                                    });
                                                }}
                                                disabled={imageZoom <= 1}
                                                style={{
                                                    backgroundColor: imageZoom > 1 ? '#f0f0f0' : 'transparent',
                                                    width: '30px',
                                                    height: '30px',
                                                    borderRadius: '6px',
                                                    padding: 0,
                                                    transition: 'all 0.15s ease'
                                                }}
                                            >
                                                <ArrowUpwardIcon style={{
                                                    fontSize: '16px',
                                                    color: imageZoom > 1 ? '#1a1a1a' : '#aaa'
                                                }} />
                                            </IconButton>
                                            <div />

                                            <IconButton
                                                onClick={() => {
                                                    setImagePosition({
                                                        x: imagePosition.x + 50,
                                                        y: imagePosition.y
                                                    });
                                                }}
                                                disabled={imageZoom <= 1}
                                                style={{
                                                    backgroundColor: imageZoom > 1 ? '#f0f0f0' : 'transparent',
                                                    width: '30px',
                                                    height: '30px',
                                                    borderRadius: '6px',
                                                    padding: 0,
                                                    transition: 'all 0.15s ease'
                                                }}
                                            >
                                                <ArrowBackIcon style={{
                                                    fontSize: '16px',
                                                    color: imageZoom > 1 ? '#1a1a1a' : '#aaa'
                                                }} />
                                            </IconButton>
                                            <IconButton
                                                onClick={() => {
                                                    setImagePosition({
                                                        x: imagePosition.x,
                                                        y: imagePosition.y - 50
                                                    });
                                                }}
                                                disabled={imageZoom <= 1}
                                                style={{
                                                    backgroundColor: imageZoom > 1 ? '#f0f0f0' : 'transparent',
                                                    width: '30px',
                                                    height: '30px',
                                                    borderRadius: '6px',
                                                    padding: 0,
                                                    transition: 'all 0.15s ease'
                                                }}
                                            >
                                                <ArrowDownwardIcon style={{
                                                    fontSize: '16px',
                                                    color: imageZoom > 1 ? '#1a1a1a' : '#aaa'
                                                }} />
                                            </IconButton>
                                            <IconButton
                                                onClick={() => {
                                                    setImagePosition({
                                                        x: imagePosition.x - 50,
                                                        y: imagePosition.y
                                                    });
                                                }}
                                                disabled={imageZoom <= 1}
                                                style={{
                                                    backgroundColor: imageZoom > 1 ? '#f0f0f0' : 'transparent',
                                                    width: '30px',
                                                    height: '30px',
                                                    borderRadius: '6px',
                                                    padding: 0,
                                                    transition: 'all 0.15s ease'
                                                }}
                                            >
                                                <ArrowForwardIcon style={{
                                                    fontSize: '16px',
                                                    color: imageZoom > 1 ? '#1a1a1a' : '#aaa'
                                                }} />
                                            </IconButton>
                                        </div>
                                    </div>

                                    {/* Rotation Controls Group */}
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        backgroundColor: 'rgba(255,255,255,0.95)',
                                        borderRadius: '12px',
                                        padding: '6px 8px',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                                        gap: '2px'
                                    }}>
                                        <IconButton
                                            onClick={() => {
                                                setImageRotation((imageRotation - 90) % 360);
                                            }}
                                            style={{
                                                backgroundColor: '#f0f0f0',
                                                width: '34px',
                                                height: '34px',
                                                borderRadius: '8px',
                                                transition: 'all 0.15s ease'
                                            }}
                                        >
                                            <RotateLeftIcon style={{
                                                fontSize: '17px',
                                                color: '#1a1a1a'
                                            }} />
                                        </IconButton>

                                        <div style={{
                                            minWidth: '48px',
                                            padding: '4px 6px',
                                            textAlign: 'center'
                                        }}>
                                            <Typography
                                                style={{
                                                    fontWeight: '700',
                                                    color: '#1a1a1a',
                                                    fontSize: '12px',
                                                    letterSpacing: '-0.2px'
                                                }}
                                            >
                                                {((imageRotation % 360 + 360) % 360)}°
                                            </Typography>
                                        </div>

                                        <IconButton
                                            onClick={() => {
                                                setImageRotation((imageRotation + 90) % 360);
                                            }}
                                            style={{
                                                backgroundColor: '#f0f0f0',
                                                width: '34px',
                                                height: '34px',
                                                borderRadius: '8px',
                                                transition: 'all 0.15s ease'
                                            }}
                                        >
                                            <RotateRightIcon style={{
                                                fontSize: '17px',
                                                color: '#1a1a1a'
                                            }} />
                                        </IconButton>
                                    </div>

                                    {/* Reset Button */}
                                    <IconButton
                                        onClick={() => {
                                            setImageZoom(1);
                                            setImagePosition({ x: 0, y: 0 });
                                            setImageRotation(0);
                                        }}
                                        disabled={imageZoom === 1 && imagePosition.x === 0 && imagePosition.y === 0 && imageRotation === 0}
                                        style={{
                                            backgroundColor: (imageZoom !== 1 || imagePosition.x !== 0 || imagePosition.y !== 0 || imageRotation !== 0)
                                                ? 'rgba(26,26,26,0.9)'
                                                : 'rgba(255,255,255,0.6)',
                                            padding: '8px 18px',
                                            borderRadius: '10px',
                                            transition: 'all 0.2s ease',
                                            boxShadow: (imageZoom !== 1 || imagePosition.x !== 0 || imagePosition.y !== 0 || imageRotation !== 0)
                                                ? '0 2px 8px rgba(0,0,0,0.12)'
                                                : 'none'
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                color: (imageZoom !== 1 || imagePosition.x !== 0 || imagePosition.y !== 0 || imageRotation !== 0)
                                                    ? '#fff'
                                                    : '#999',
                                                fontWeight: '600',
                                                fontSize: '13px',
                                                letterSpacing: '0.2px'
                                            }}
                                        >
                                            Reset
                                        </Typography>
                                    </IconButton>

                                    {/* Save Rotation Button */}
                                    <IconButton
                                        onClick={handleSaveRotation}
                                        disabled={imageRotation === 0 || isSavingRotation}
                                        style={{
                                            backgroundColor: (imageRotation !== 0 && !isSavingRotation)
                                                ? 'rgba(102,187,106,0.9)'
                                                : 'rgba(255,255,255,0.6)',
                                            padding: '8px 18px',
                                            borderRadius: '10px',
                                            transition: 'all 0.2s ease',
                                            boxShadow: (imageRotation !== 0)
                                                ? '0 2px 8px rgba(102,187,106,0.25)'
                                                : 'none'
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                color: (imageRotation !== 0 && !isSavingRotation)
                                                    ? '#fff'
                                                    : '#999',
                                                fontWeight: '600',
                                                fontSize: '13px',
                                                letterSpacing: '0.2px'
                                            }}
                                        >
                                            {isSavingRotation ? 'Saving...' : 'Save'}
                                        </Typography>
                                    </IconButton>

                                    {/* Download Current Image Button */}
                                    <IconButton
                                        onClick={handleDownloadCurrentImage}
                                        disabled={isDownloading || !selectedImage}
                                        style={{
                                            backgroundColor: !isDownloading
                                                ? 'rgba(33,150,243,0.9)'
                                                : 'rgba(255,255,255,0.6)',
                                            padding: '8px 18px',
                                            borderRadius: '10px',
                                            transition: 'all 0.2s ease',
                                            boxShadow: !isDownloading
                                                ? '0 2px 8px rgba(33,150,243,0.25)'
                                                : 'none',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px'
                                        }}
                                    >
                                        <GetAppIcon style={{
                                            fontSize: '17px',
                                            color: !isDownloading ? '#fff' : '#999'
                                        }} />
                                        <Typography
                                            style={{
                                                color: !isDownloading ? '#fff' : '#999',
                                                fontWeight: '600',
                                                fontSize: '13px',
                                                letterSpacing: '0.2px'
                                            }}
                                        >
                                            {isDownloading ? language.downloading : language.download}
                                        </Typography>
                                    </IconButton>
                                </div>
                            </>
                        )}
                    </DialogContent>
                </Dialog>
            )}

            <Backdrop className={classes.backdrop} open={isDownloading}>
                <div className={classes.loadingContainer}>
                    <div className={classes.loadingIconWrapper}>
                        <div className={classes.loadingPulse}></div>
                        <div className={classes.loadingRing}></div>
                        <CloudDownloadIcon className={classes.loadingIcon} />
                    </div>
                    <Typography variant="h6" style={{ color: '#fff', fontWeight: 'bold', letterSpacing: '1px', textTransform: 'uppercase', fontSize: '1.1rem' }}>
                        Preparing Download...
                    </Typography>
                    <Typography variant="body2" style={{ marginTop: 8, color: 'rgba(255, 255, 255, 0.7)', fontWeight: 300 }}>
                        Processing your images...
                    </Typography>
                </div>
            </Backdrop>

        </div>
    )
}
